import { Analytics } from './analytics';
import GoogleAnalytics from './google';

const analytics: Analytics = new GoogleAnalytics();

export default analytics;
